import { useMemo, useState } from "react";
import { RelayPassport } from "../../relay/RelayTypes";

const reachedMilestone = (passport: RelayPassport) => {
  const choices = [
    ...[2, 5, 10, 25, 50, 100].filter((n) => passport.countryCount >= n).map((n) => ({ score: n * 1000, label: `${n} countries`, detail: "This feeling crossed borders." })),
    ...[5, 10, 25, 50, 100].filter((n) => passport.descendantCount >= n).map((n) => ({ score: n * 100, label: `${n} people`, detail: "One thoughtful moment became many." })),
    ...[5, 10, 25, 50, 100].filter((n) => passport.stopCount >= n).map((n) => ({ score: n, label: `${n} stops`, detail: "This banana keeps moving." })),
  ];
  return choices.sort((a, b) => b.score - a.score)[0];
};

export const PassportMilestoneCard = ({ passport }: { passport: RelayPassport }) => {
  const milestone = useMemo(() => reachedMilestone(passport), [passport]);
  const storageKey = `tuttobanana-milestone-${passport.serialNumber}`;
  const [shared, setShared] = useState(() => milestone ? localStorage.getItem(storageKey) === milestone.label : false);
  if (!milestone || shared) return null;

  const shareCard = async () => {
    const canvas = document.createElement("canvas");
    canvas.width = 1080; canvas.height = 1920;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.fillStyle = "#111827"; ctx.fillRect(0, 0, 1080, 1920);
    ctx.fillStyle = "#facc15"; ctx.beginPath(); ctx.arc(540, 420, 250, 0, Math.PI * 2); ctx.fill();
    ctx.textAlign = "center"; ctx.fillStyle = "#111827"; ctx.font = "bold 220px sans-serif"; ctx.fillText("🍌", 540, 500);
    ctx.fillStyle = "#facc15"; ctx.font = "bold 54px sans-serif"; ctx.fillText("BANANA PASSPORT MILESTONE", 540, 820);
    ctx.fillStyle = "white"; ctx.font = "bold 150px sans-serif"; ctx.fillText(milestone.label.toUpperCase(), 540, 1040);
    ctx.font = "48px sans-serif"; ctx.fillStyle = "#d1d5db"; ctx.fillText(milestone.detail, 540, 1145);
    ctx.font = "bold 58px sans-serif"; ctx.fillStyle = "white"; ctx.fillText("Tiny Gift. Big Feeling.", 540, 1510);
    ctx.font = "40px sans-serif"; ctx.fillStyle = "#facc15"; ctx.fillText("tuttobanana.com", 540, 1600);
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/png"));
    if (!blob) return;
    const file = new File([blob], `banana-${passport.serialNumber}-milestone.png`, { type: "image/png" });
    if (navigator.share && navigator.canShare?.({ files: [file] })) {
      await navigator.share({ files: [file], title: "My Banana Passport milestone" });
    } else {
      const link = document.createElement("a"); link.href = URL.createObjectURL(blob); link.download = file.name; link.click(); URL.revokeObjectURL(link.href);
    }
    localStorage.setItem(storageKey, milestone.label); setShared(true);
  };

  return <section className="rounded-2xl border-2 border-yellow-400 bg-yellow-50 p-5 text-center">
    <p className="text-xs font-black uppercase tracking-[0.2em] text-yellow-700">A new Passport milestone!</p>
    <h3 className="mt-2 text-2xl font-black">Your banana reached {milestone.label} 🎉</h3>
    <p className="mt-2 text-sm text-gray-600">{milestone.detail}</p>
    <button type="button" onClick={shareCard} className="mt-4 rounded-full bg-gray-900 px-6 py-3 font-bold text-white hover:bg-black">Share the milestone</button>
  </section>;
};
